import jwtDecode from "jwt-decode";

import store from "@/store";
import api from "@/services/api";
import config from "@/services/config";
import sentryService from "@/services/sentry";
import segmentService from "@/services/segment";
import conversationService from "@/services/conversation";

const authService = {};
const endpoint = "/auth/token";

authService.authenticate = function (username, password) {
  return api
    .post(endpoint, { username, password })
    .then((res) => {
      if (res.data.user?.doctor) {
        res.data.user.doctor.selectedBox = null;
      }
      store.commit("setToken", res.data.token);
      store.commit("setUser", res.data.user);
      sentryService.setUser();
      segmentService.setUser();
      // UC-REG-067 + UC-REG-068. Hidratar branding + flags de la org del
      // user en runtime. Fail-silent: si el endpoint falla, el dashboard cae
      // al branding del tenant (env vars del build).
      store.dispatch("loadOrganizationContext");
      return res.data;
    })
    .then(({ token, user }) => {
      const isPatient = user.role === "Paciente";
      const payload = jwtDecode(token);
      if (!isPatient && !payload.aud.includes(config.audience)) {
        this.clearToken();
        return Promise.reject(new Error("INVALID_AUDIENCE"));
      }

      return { user };
    });
};

// Note: I think this does not make sense, if we are going to use vuex, we should
//       retrieve the data from vuex directly.
authService.getToken = function () {
  return store.state.token;
};

// Note: Rename clearToken to clear session or something like that, we are not managing
//       just tokens now.
authService.clearToken = function () {
  store.commit("setToken", "");
  store.commit("setUser", {});
  // UC-REG-067 — limpiar contexto de la org al logout para que el próximo
  // user vea el branding correcto (sin cache cruzado).
  store.commit("clearOrganizationContext");

  const twilioClient = conversationService.getClient();

  if (twilioClient) {
    twilioClient.shutdown();
  }

  conversationService.setClient(null);
  conversationService.setClientPromise(null);
};

export default authService;
